import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductApprovalsBulkActionModalTriggerEntityParams {
  selectedProducts: number[];
  action: string;
}
export class ProductApprovalsBulkActionModalTriggerEntity extends BaseEntityClass {
  selected_products: number[];
  action: string;
  constructor(params: ProductApprovalsBulkActionModalTriggerEntityParams) {
    super();
    this.type = "product_approvals_bulk_actions_modal_trigger";
    this.entity_version = 2;
    this.selected_products = params.selectedProducts;
    this.action = params.action;
  }
}
